<template>
  <div class="calendar-chart">
    <div class="calendar-chart-main">
      <datetime-picker
        :visible="true"
        :disabledWeekView="true"
        :scrollChangeDate="false"
        :markDate="markDate"
        format="YY-MM-DD"
        pickerType="date"
        @change="handleChange"
        @slidechange="handleSlideChange"
      ></datetime-picker>
    </div>
    <div class="calendar-chart-content">
      <div class="calendar-chart-add" @click="handleCreate">
        <x-svg-icon name="add"></x-svg-icon>
      </div>
      <x-loading :visible="loading">
        <template v-for="calendar in calendarData">
          <div :key="calendar.documentId" class="calendar-chart-content-item" @click="handleClick(calendar)">
            <div class="calendar-chart-content-tag">
              <span class="content-item-title">{{ calendar.eventTitle }}</span>
            </div>
          </div>
        </template>
        <template v-if="calendarData.length === 0">
          <x-empty>
            <span class="empty-text">所选日期暂无数据</span>
          </x-empty>
        </template>
      </x-loading>
    </div>
    <div class="calendar-chart-footer" @click="handleDetail">
      <span class="calendar-chart-footer-label">查看更多</span>
      <x-svg-icon class="calendar-chart-footer-value" name="arrow-right-icon"></x-svg-icon>
    </div>
  </div>
</template>

<script>
import DatetimePicker from '@/components/df-calendar/DatetimePicker.vue'
// import 'vue-hash-calendar/lib/vue-hash-calendar.css'
import { mapState } from 'vuex'
import apis from '@/api'
import CalendarUtil from '@/util/calendar.util.js'

export default {
  components: {
    DatetimePicker: DatetimePicker
  },
  props: {
    chartConfig: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      markDate: [],
      calendarData: [],
      touchStartPositionY: 0,
      slideDate: new Date()
    }
  },
  computed: {
    ...mapState({
      theme: state => state.themeModule.theme
    }),

    themeColor() {
      return this.theme.currentThemeColor.color
    }
  },
  created() {
    this.queryMarkData(this.slideDate)
  },
  methods: {
    refresh() {
      this.queryMarkData(this.slideDate)
      this.queryData(this.$dayjs(this.slideDate).format('YYYY-MM-DD'))
    },
    handleChange(date) {
      this.slideDate = date
      this.queryData(date)
    },
    handleSlideChange(direction) {
      if (direction === 'left') {
        this.slideDate = CalendarUtil.getOtherMonth(this.slideDate, 'nextMonth')
      } else if (direction === 'right') {
        this.slideDate = CalendarUtil.getOtherMonth(this.slideDate, 'preMonth')
      }
      this.queryMarkData(this.slideDate)
    },
    queryData(date) {
      const request = {
        ...apis.FORM.QUERY_CALENDAR_BY_MONTH,
        params: {
          startOfTimeInterval: date,
          endOfTimeInterval: date,
          reportChart: {
            ...this.chartConfig
          }
        }
      }
      this.loading = true
      this.$request(request).asyncThen(resp => {
        this.loading = false
        if (resp.code === 'ok') {
          this.calendarData = resp.data.slice(0, 3)
        }
      }, (err) => {
        this.loading = false
      }).asyncErrorCatch(err => {
        this.loading = false
      })
    },
    handleCreate() {
      this.$router.push({
        name: 'form',
        query: {
          title: this.chartConfig.sourceFormName,
          formId: this.chartConfig.sourceForm,
          appId: this.$route.query.appId,
          processId: this.chartConfig.sourceProcessId
        }
      })
    },
    handleClick(calendar) {
      this.$router.push({
        name: 'form',
        query: {
          title: this.chartConfig.sourceFormName,
          formId: this.chartConfig.sourceForm,
          processId: this.chartConfig.sourceProcessId,
          documentId: calendar.documentId,
          // taskId: item.taskId,
          appId: this.$route.query.appId
        }
      })
    },
    handleDetail() {
      this.$router.push({
        name: 'appList',
        query: {
          title: this.chartConfig.sourceFormName,
          formId: this.chartConfig.sourceForm,
          appId: this.$route.query.appId,
          processId: this.chartConfig.sourceProcessId
        }
      })
    },
    queryMarkData(date) {
      const request = {
        ...apis.FORM.QUERY_CALENDAR_MONTH_MARK_DATE,
        params: {
          startOfTimeInterval: this.$dayjs(date).startOf('month').format('YYYY-MM-DD'),
          endOfTimeInterval: this.$dayjs(date).endOf('month').format('YYYY-MM-DD'),
          reportChart: {
            ...this.chartConfig
          }
        }
      }
      this.$request(request).asyncThen(resp => {
        if (resp.code === 'ok') {
          this.markDate = [{
            color: this.themeColor,
            date: resp.data
          }]
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar-chart::v-deep {
  .calendar-chart-main {
    .calendar_title {
      background-color: transparent;
    }
    .calendar_first_today, .calendar_confirm {
      color: $--app-primary-color;
    }
    .calendar_item {
      position: relative;
      height: 2.286rem !important;
    }
    .calendar_day {
      width: 1.8rem;
      height: 1.8rem;
      margin-bottom: -0.36rem;
    }
    .calendar_day_today {
      background-color: transparent;
      color: $--app-primary-color;
    }
    .calendar_day_checked {
      background-color: $--app-primary-color;
      color: $--app-white-font-color !important;
    }
  }
  .calendar-chart-content {
    position: relative;
    display: flex;
    align-items: center;
    height: 8.285rem;
    padding: 0.57rem 0;
    box-sizing: border-box;
    .calendar-chart-content-item {
      display: flex;
      margin-bottom: 0.57rem;
      &:last-child {
        margin-bottom: 0;
      }
      .calendar-chart-content-tag {
        font-size: 0;
        display: flex;
        align-items: center;
        width: 100%;
        box-sizing: border-box;
        padding: 0 0.857rem;
        height: 2rem;
        background-color: $--app-selected-color;
        .content-item-title {
          font-size: $--app-base-font-size;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 2rem;
          line-height: 2rem;
        }
      }
    }
    .x-empty {
      position: relative;
      top: 1rem;
    }
    .x-loading {
      text-align: center;
      width: 100%;
    }
    .x-loading, .x-loading > img {
      height: 100%;
    }
    .calendar-chart-add {
      position: absolute;
      bottom: 0.5rem;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3rem;
      height: 3rem;
      border-radius: 50%;
      color: $--app-white-font-color;
      background-color: $--app-primary-color;
      z-index: 1000;
    }
  }
  .calendar-chart-footer {
    position: relative;
    font-size: 0.857rem;
    color: $--app-notice-color;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    border-top: 1px solid $--app-split-line-color;
    height: 2rem;
    .calendar-chart-footer-value {
      position: absolute;
      right: 0;
      top: .5rem;
    }
  }
}
</style>
